import { ENDPOINT_CARTS, ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const putEmptyCart = ({ id, name }) => {
  const params = {
    name,
  };

  return axiosAuth
    .put(`${ENDPOINT_ROOT}/${ENDPOINT_CARTS}/${id}/empty`, params)
    .then((res) => res.data);
};

export default putEmptyCart;
